const I = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
var u;
(function(t) {
  t.Base32IncorrectEncoding = "B32_ENC_INVALID", t.DecodeTimeInvalidCharacter = "DEC_TIME_CHAR", t.DecodeTimeValueMalformed = "DEC_TIME_MALFORMED", t.EncodeTimeNegative = "ENC_TIME_NEG", t.EncodeTimeSizeExceeded = "ENC_TIME_SIZE_EXCEED", t.EncodeTimeValueMalformed = "ENC_TIME_MALFORMED", t.PRNGDetectFailure = "PRNG_DETECT", t.ULIDInvalid = "ULID_INVALID", t.Unexpected = "UNEXPECTED", t.UUIDInvalid = "UUID_INVALID";
})(u || (u = {}));
class m extends Error {
  constructor(e, n) {
    super(`${n} (${e})`), this.name = "ULIDError", this.code = e;
  }
}
function N(t) {
  let e = Math.floor(t() * 32);
  return e === 32 && (e = 31), I.charAt(e);
}
function w(t) {
  const e = M(), n = e && (e.crypto || e.msCrypto) || null;
  if (typeof (n == null ? void 0 : n.getRandomValues) == "function")
    return () => {
      const a = new Uint8Array(1);
      return n.getRandomValues(a), a[0] / 255;
    };
  if (typeof (n == null ? void 0 : n.randomBytes) == "function")
    return () => n.randomBytes(1).readUInt8() / 255;
  throw new m(u.PRNGDetectFailure, "Failed to find a reliable PRNG");
}
function M() {
  return D() ? self : typeof window < "u" ? window : typeof global < "u" ? global : typeof globalThis < "u" ? globalThis : null;
}
function R(t, e) {
  let n = "";
  for (; t > 0; t--)
    n = N(e) + n;
  return n;
}
function k(t, e = 10) {
  if (isNaN(t))
    throw new m(u.EncodeTimeValueMalformed, `Time must be a number: ${t}`);
  if (t > 281474976710655)
    throw new m(u.EncodeTimeSizeExceeded, `Cannot encode a time larger than ${281474976710655}: ${t}`);
  if (t < 0)
    throw new m(u.EncodeTimeNegative, `Time must be positive: ${t}`);
  if (Number.isInteger(t) === !1)
    throw new m(u.EncodeTimeValueMalformed, `Time must be an integer: ${t}`);
  let n, a = "";
  for (let r = e; r > 0; r--)
    n = t % 32, a = I.charAt(n) + a, t = (t - n) / 32;
  return a;
}
function D() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
function _(t, e) {
  const n = w(), a = Date.now();
  return k(a, 10) + R(16, n);
}
const L = (t) => Object.keys(t).reduce(
  (e, n) => (t[n] !== void 0 && (e[n] = t[n]), e),
  {}
), K = (t, e, n) => {
  const a = new URL(`${e.baseUrl}/${t}`), r = new URLSearchParams({
    category: n.category,
    action: n.action
  });
  return a.search = r.toString(), a.toString();
}, b = (t) => {
  const e = {
    "Content-Type": "application/json"
  };
  return t.apiToken != null ? { ...e, "X-API-TOKEN": t.apiToken } : e;
}, U = (t) => {
  const {
    env: e,
    staticParams: n,
    meta: a,
    pageViewId: r,
    requestId: g,
    localTimestamp: i,
    extraParams: o
  } = t, { apiToken: c, ...l } = L(a), d = {
    action: n.action,
    category: n.category,
    ...l,
    referer: a.referer,
    pageViewId: r,
    localTime: i,
    env: e,
    requestId: g
  };
  return o !== void 0 && (d.extraParams = o), d;
};
var p = /* @__PURE__ */ ((t) => (t[t.UNSPECIFIED = 0] = "UNSPECIFIED", t[t.PAGE = 1] = "PAGE", t[t.EVENT = 2] = "EVENT", t[t.IMPRESSION = 3] = "IMPRESSION", t[t.ABTEST = 4] = "ABTEST", t))(p || {});
const V = "8.2.0", O = (t) => ({
  page: p.PAGE,
  event: p.EVENT,
  impression: p.IMPRESSION,
  ab_test: p.ABTEST
})[t] ?? p.UNSPECIFIED, F = (t, e) => {
  const n = new URL(t.baseUrl);
  n.pathname = `${n.pathname.replace(/\/$/, "")}/log`;
  const a = new URLSearchParams({
    category: e.category,
    action: e.action
  });
  return n.search = a.toString(), n.toString();
}, q = (t) => {
  const e = {
    "Content-Type": "application/json"
  };
  return t.apiToken != null ? { ...e, "X-API-TOKEN": t.apiToken } : e;
}, G = () => V, B = (t) => {
  const {
    env: e,
    service: n,
    config: a,
    staticParams: r,
    meta: g,
    pageViewId: i,
    requestId: o,
    localTimestamp: c,
    longSessionId: l,
    shortSessionId: d,
    extraParams: s
  } = t;
  return {
    userSession: {
      longSessionId: l,
      shortSessionId: d
    },
    webBrowser: {
      userAgent: navigator.userAgent,
      userAgentClientHint: JSON.stringify(navigator.userAgentData),
      ltlpVersion: G()
    },
    serviceEnvironment: {
      env: e,
      name: a.serviceName || n,
      serviceLastCommittedAt: a ? a.serviceLastCommittedAt : ""
    },
    localTimestamp: c,
    url: g.url,
    referer: g.referer,
    category: O(r.category),
    action: r.action,
    extraParams: s ? JSON.stringify(s) : "{}",
    pageViewId: i,
    requestId: o
  };
}, x = async (t) => {
  const e = `${t.baseUrl.replace(/\/$/, "")}/session`, n = await fetch(e, {
    credentials: "include"
  });
  if (!n.ok)
    throw new Error("Failed to fetch session");
  const a = await n.json();
  return {
    longSessionId: a.LongSession.ID,
    shortSessionId: a.ShortSession.ID
  };
}, $ = (t, e) => {
  let n = {
    initialized: !1
  };
  const a = [], r = x(t).then(
    async ({ longSessionId: i, shortSessionId: o }) => {
      n = {
        initialized: !0,
        longSessionId: i,
        shortSessionId: o
      };
      for (const c of a)
        c({
          longSessionId: i,
          shortSessionId: o
        });
      return a.length = 0, {
        longSessionId: i,
        shortSessionId: o
      };
    }
  );
  return {
    enqueueRequest: (i, o) => {
      const c = e(o);
      n.initialized ? i({
        longSessionId: n.longSessionId,
        shortSessionId: n.shortSessionId,
        ...c
      }) : a.push(async ({ longSessionId: l, shortSessionId: d }) => {
        await i({
          longSessionId: l,
          shortSessionId: d,
          ...c
        });
      });
    },
    sessionIdsPromise: r
  };
}, h = (t) => {
  let e = _();
  return (n) => {
    const { enqueueRequest: a, sessionIdsPromise: r } = $(
      n,
      ({ staticLogParams: o }) => {
        o.shouldUpdatePageViewId && (e = _());
        const c = (/* @__PURE__ */ new Date()).toISOString(), l = _();
        return {
          pageViewId: e,
          localTimestamp: c,
          requestId: l
        };
      }
    ), g = (o) => {
      if (o instanceof Error) {
        if (n.onError) {
          n.onError(o);
          return;
        }
        throw o;
      }
    };
    return {
      defineLog: (o) => {
        const {
          shouldUpdatePageViewId: c = !1,
          keepalive: l = !0,
          ...d
        } = o, s = {
          shouldUpdatePageViewId: c,
          keepalive: l,
          ...d
        }, C = K(
          t,
          n,
          s
        );
        return (v, f) => {
          a(
            async ({
              longSessionId: T,
              shortSessionId: A,
              pageViewId: P,
              localTimestamp: E,
              requestId: S
            }) => {
              await Promise.all([
                (async () => {
                  await fetch(C, {
                    method: "POST",
                    headers: b(v),
                    body: JSON.stringify(
                      U({
                        env: n.env,
                        staticParams: s,
                        meta: v,
                        pageViewId: P,
                        requestId: S,
                        localTimestamp: E,
                        extraParams: f
                      })
                    ),
                    credentials: "include",
                    referrerPolicy: "unsafe-url",
                    keepalive: s.keepalive
                  });
                })().catch(g),
                (async () => {
                  const y = n.v2;
                  y != null && await fetch(
                    F(y, s),
                    {
                      method: "POST",
                      headers: q(v),
                      body: JSON.stringify(
                        B({
                          env: n.env,
                          service: t,
                          config: y,
                          staticParams: s,
                          meta: v,
                          pageViewId: P,
                          requestId: S,
                          localTimestamp: E,
                          longSessionId: T,
                          shortSessionId: A,
                          extraParams: f
                        })
                      ),
                      credentials: "include",
                      referrerPolicy: "unsafe-url",
                      keepalive: s.keepalive
                    }
                  );
                })().catch(g)
              ]);
            },
            {
              staticLogParams: s
            }
          );
        };
      },
      sessionIdsPromise: r
    };
  };
}, W = (t) => {
  const { defineLog: e, sessionIdsPromise: n } = h("shadow")(t);
  return {
    logger: {
      page: {
        view: e({
          category: "page",
          action: "view",
          shouldUpdatePageViewId: !0
        }),
        hide: e({
          category: "page",
          action: "hide"
        }),
        notFound: e({
          category: "page",
          action: "not_found"
        })
      },
      event: {
        sendChat: e({ category: "event", action: "send_chat" }),
        startDiagnosis: e({
          category: "event",
          action: "start_diagnosis"
        }),
        answerDiagnosis: e({ category: "event", action: "answer_diagnosis" }),
        abortDiagnosis: e({
          category: "event",
          action: "abort_diagnosis"
        }),
        finishDiagnosis: e({
          category: "event",
          action: "finish_diagnosis"
        }),
        clickDiagnosisContent: e({ category: "event", action: "click_diagnosis_content" }),
        showRegisteredDiagnosisResult: e({
          category: "event",
          action: "show_registered_diagnosis_result"
        }),
        restartDiagnosis: e({
          category: "event",
          action: "restart_diagnosis"
        }),
        resumeDiagnosis: e({
          category: "event",
          action: "resume_diagnosis"
        }),
        registerAccount: e({
          category: "event",
          action: "register_account"
        }),
        getPreviousSession: e({
          category: "event",
          action: "get_previous_session"
        }),
        searchPlanner: e({
          category: "event",
          action: "search_planner"
        }),
        matchingPlanner: e({
          category: "event",
          action: "matching_planner"
        }),
        failedSearchPlanner: e({ category: "event", action: "failed_search_planner" }),
        contact: e({ category: "event", action: "contact" }),
        onayami: e({ category: "event", action: "onayami" }),
        // ABテスト終わったら消す
        shadow811: e({
          category: "event",
          action: "shadow811"
        }),
        karteUserComment: e({
          category: "event",
          action: "karte_user_comment"
        }),
        karteUserTopics: e({
          category: "event",
          action: "karte_user_topics"
        }),
        createRoom: e({
          category: "event",
          action: "create_room"
        }),
        revisitMatchingPlanner: e({
          category: "event",
          action: "revisit_matching_planner"
        }),
        clickLinkButton: e({
          category: "event",
          action: "click_link_button"
        }),
        applySeminar: e({
          category: "event",
          action: "apply_seminar"
        }),
        clickExternalCalendarIntegrationButton: e({
          category: "event",
          action: "click_external_calendar_integration_button"
        }),
        inputPostalCode: e({
          category: "event",
          action: "input_postal_code"
        }),
        viewExternalPage: e({
          category: "event",
          action: "view_external_page"
        }),
        chatOkaneko: e({
          category: "event",
          action: "chat_okaneko",
          keepalive: !1
        }),
        retryLineLogin: e({
          category: "event",
          action: "retry_line_login"
        }),
        setChannelId: e({
          category: "event",
          action: "set_channel_id"
        }),
        updateInsuranceProductDocumentRequestCart: e({
          category: "event",
          action: "update_insurance_product_document_request_cart"
        }),
        requestInsuranceProductDocument: e({
          category: "event",
          action: "request_insurance_product_document"
        }),
        requestInsuranceProductConsultation: e({
          category: "event",
          action: "request_insurance_product_consultation"
        }),
        startInsuranceProductWebApplication: e({
          category: "event",
          action: "start_insurance_product_web_application"
        }),
        clickDirectMatchingButtonOnTopPage: e({
          category: "event",
          action: "click_direct_matching_button_on_top_page"
        }),
        reserveBookingRequestTimeSlots: e({
          category: "event",
          action: "reserveBookingRequestTimeSlots"
        })
      },
      impression: {
        areaListedPlanner: e({ category: "impression", action: "area_listed_planner" }),
        areaInviewPlanner: e({ category: "impression", action: "area_inview_planner" }),
        inviewKarte: e({
          category: "impression",
          action: "inview_karte"
        }),
        inviewKartePlannerComment: e({
          category: "impression",
          action: "inview_karte_planner_comment"
        }),
        inviewDiagnosisTopicsAndConcerns: e({
          category: "impression",
          action: "inview_diagnosis_topics_and_concerns"
        }),
        inviewAd: e({
          category: "impression",
          action: "inview_ad"
        }),
        inviewBanner: e({
          category: "impression",
          action: "inview_ad"
        }),
        inviewSeminarLink: e({
          category: "impression",
          action: "inview_seminar_link"
        })
      },
      abTest: {
        chosen: e({
          category: "ab_test",
          action: "chosen"
        })
      }
    },
    sessionIdsPromise: n
  };
}, X = (t) => {
  const { defineLog: e, sessionIdsPromise: n } = h("dolphin")(t);
  return {
    logger: {
      page: {
        view: e({
          category: "page",
          action: "view",
          shouldUpdatePageViewId: !0
        }),
        hide: e({
          category: "page",
          action: "hide"
        }),
        error: e({
          category: "page",
          action: "error"
        })
      },
      event: {
        updateProfile: e({
          category: "event",
          action: "updateProfile"
        }),
        updateCorporation: e({
          category: "event",
          action: "updateCorporation"
        }),
        updateAccount: e({
          category: "event",
          action: "updateAccount"
        }),
        displayAdvice: e({
          category: "event",
          action: "displayAdvice"
        }),
        feedbackAdvice: e({
          category: "event",
          action: "feedbackAdvice"
        }),
        loadPastMessages: e({
          category: "event",
          action: "loadPastMessages"
        }),
        speechInput: e({
          category: "event",
          action: "speechInput"
        }),
        openDiagnosisModal: e({
          category: "event",
          action: "openDiagnosisModal"
        }),
        downloadQr: e({
          category: "event",
          action: "downloadQr"
        }),
        openFAQPage: e({
          category: "event",
          action: "openFAQPage"
        }),
        sendKartePlannerComment: e({
          category: "event",
          action: "sendKartePlannerComment"
        }),
        preSendKartePlannerComment: e({
          category: "event",
          action: "preSendKartePlannerComment"
        }),
        displayKarteUserList: e({
          category: "event",
          action: "getKarteUserList"
        }),
        applyKarteUserFilteringRule: e({
          category: "event",
          action: "applyKarteUserFilteringRule"
        }),
        // カルテの絞り込み条件の保存
        saveKarteUserFilteringRule: e({
          category: "event",
          action: "saveKarteUserFilteringRule"
        }),
        // カルテの絞り込み条件の削除
        removeKarteUserFilteringRule: e({
          category: "event",
          action: "removeKarteUserFilteringRule"
        }),
        // カルテの絞り込み条件の更新
        updateKarteUserFilteringRule: e({
          category: "event",
          action: "updateKarteUserFilteringRule"
        }),
        selectKarteCommentTemplate: e({ category: "event", action: "selectKarteCommentTemplate" }),
        createKarteCommentTemplate: e({
          category: "event",
          action: "createKarteCommentTemplate"
        }),
        updateKarteCommentTemplate: e({
          category: "event",
          action: "updateKarteCommentTemplate"
        }),
        insertKarteCommentTemplate: e({ category: "event", action: "insertKarteCommentTemplate" }),
        editKarteCommentTemplate: e({
          category: "event",
          action: "editKarteCommentTemplate"
        }),
        cancelEditingKarteCommentTemplate: e({
          category: "event",
          action: "cancelEditingKarteCommentTemplate"
        }),
        removeKarteCommentTemplate: e({
          category: "event",
          action: "removeKarteCommentTemplate"
        }),
        showKarteDetailModal: e({
          category: "event",
          action: "showKarteDetailModal"
        }),
        showPickupWaitingKarteUsers: e({
          category: "event",
          action: "showPickupWaitingKarteUsers"
        }),
        clickReloadPickupWaitingKarteUsersButton: e({
          category: "event",
          action: "clickReloadPickupWaitingKarteUsersButton"
        }),
        sendChatMessage: e({
          category: "event",
          action: "sendChatMessage"
        }),
        sendChatSelectionMessage: e({
          category: "event",
          action: "sendChatSelectionMessage"
        }),
        click: e({
          category: "event",
          action: "click"
        }),
        clickSolicitorCloudDocument: e({
          category: "event",
          action: "clickSolicitorCloudDocument"
        }),
        searchSolicitorCloudCoverage: e({
          category: "event",
          action: "searchSolicitorCloudCoverage"
        }),
        updateAutoPostKartePlannerCommentSetting: e({
          category: "event",
          action: "updateAutoPostKartePlannerCommentSetting"
        }),
        createAutoChatReplySetting: e({
          category: "event",
          action: "createAutoChatReplySetting"
        }),
        updateAutoChatReplySetting: e({
          category: "event",
          action: "updateAutoChatReplySetting"
        }),
        deleteAutoChatReplySettings: e({
          category: "event",
          action: "deleteAutoChatReplySettings"
        }),
        // 初期チャットメッセージは1プランナー1つのみ
        // かつ、初期チャットメッセージは削除ができないので、
        // createdAtを見れば作成した日がわかるのであえてcreateとupdateを分けない
        saveDefaultIntroductionMessage: e({
          category: "event",
          action: "saveDefaultIntroductionMessage"
        }),
        createConditionalIntroductionMessage: e({
          category: "event",
          action: "createConditionalIntroductionMessage"
        }),
        updateConditionalIntroductionMessage: e({
          category: "event",
          action: "updateConditionalIntroductionMessage"
        }),
        removeConditionalIntroductionMessage: e({
          category: "event",
          action: "removeConditionalIntroductionMessage"
        }),
        saveNormalMessageChatReplyPlannerSetting: e({
          category: "event",
          action: "saveNormalMessageChatReplyPlannerSetting"
        }),
        enableNormalMessageChatReplyMatchSetting: e({
          category: "event",
          action: "enableNormalMessageChatReplyMatchSetting"
        }),
        disableNormalMessageChatReplyMatchSetting: e({
          category: "event",
          action: "disableNormalMessageChatReplyMatchSetting"
        }),
        //
        createAttackListSenderSetting: e({
          category: "event",
          action: "createAttackListSenderSetting"
        }),
        updateAttackListSenderSetting: e({
          category: "event",
          action: "updateAttackListSenderSetting"
        }),
        deleteAttackListSenderSettings: e({
          category: "event",
          action: "deleteAttackListSenderSettings"
        }),
        createCalendarSetting: e({
          category: "event",
          action: "createCalendarSetting"
        }),
        updateCalendarSetting: e({
          category: "event",
          action: "updateCalendarSetting"
        }),
        deleteCalendarSetting: e({
          category: "event",
          action: "deleteCalendarSetting"
        }),
        saveScheduleAdjustmentDefaultCalendars: e({
          category: "event",
          action: "saveScheduleAdjustmentDefaultCalendars"
        }),
        createPlannerAccount: e({
          category: "event",
          action: "createPlannerAccount"
        }),
        updatePlannerAccount: e({
          category: "event",
          action: "updatePlannerAccount"
        }),
        deletePlannerAccount: e({
          category: "event",
          action: "deletePlannerAccount"
        }),
        updatePlannerAccountRole: e({
          category: "event",
          action: "updatePlannerAccountRole"
        }),
        assignPlannerAccountToMatch: e({
          category: "event",
          action: "assignPlannerAccountToMatch"
        }),
        unassignPlannerAccountFromMatch: e({
          category: "event",
          action: "unassignPlannerAccountFromMatch"
        })
      },
      abTest: {
        abTest: e({
          category: "ab_test",
          action: "ab_test"
        })
      }
    },
    sessionIdsPromise: n
  };
}, z = (t) => {
  const { defineLog: e, sessionIdsPromise: n } = h("okane-kollege")(t);
  return {
    logger: {
      page: {
        view: e({
          category: "page",
          action: "view",
          shouldUpdatePageViewId: !0
        }),
        hide: e({
          category: "page",
          action: "hide"
        }),
        notFound: e({
          category: "page",
          action: "not_found"
        })
      }
    },
    sessionIdsPromise: n
  };
};
export {
  X as createDolphinLogger,
  z as createOkaneKollegeLogger,
  W as createShadowLogger
};
//# sourceMappingURL=index.mjs.map
